<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-4">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="onChangeDate" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-3">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-3">
          </div> -->
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <b-table  @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(date)="data">
            {{parseDate(data.item.date)}}
          </template>
          <template v-slot:cell(pha_status)="data">
            <b-badge v-if="data.item.pt_planner_activity_id == 2" variant="success">PHA Appointment</b-badge>
            <b-badge v-else variant="danger">-</b-badge>
          </template>
          <template v-slot:cell(show_status)="data">
            <b-badge v-if="data.item.show_status == 1" variant="success">Yes</b-badge>
            <b-badge v-else variant="danger">No</b-badge>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button v-if="getRoleId != '33'" size="sm" @click="openPage('/memberPhaAssign/assign?id=' + data.item.id + '&last_page=' + currentPage)" class="btn-table green mr-1">
              <i class="far fa-eye"></i> Assign
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'memberPhaAssign',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'member_name',
          label: 'Member Name',
          formatter: (value, key, item) => {
            return (item.member ? item.member.first_name + ' ' + item.member.last_name : '-')
          },
          sortable: false
        },
        {
          key: 'member.branch.name',
          label: 'Branch',
          sortable: false
        },
        {
          key: 'email',
          label: 'Email',
          formatter: (value, key, item) => {
            return (item.member ? item.member.email : '-')
          },
          sortable: false
        },
        {
          key: 'phone',
          label: 'Phone Number',
          formatter: (value, key, item) => {
            return (item.member ? item.member.phone_number : '-')
          },
          sortable: false
        },
        {
          key: 'membership_last_buy_name',
          label: 'Membership Type',
          formatter: (value, key, item) => {
            return (item.member ? item.member.membership_last_buy_name : '-')
          },
          sortable: false
        },
        {
          key: 'membership_status_name',
          label: 'Membership Status',
          formatter: (value, key, item) => {
            return (item.member ? item.member.membership_status.name : '-')
          },
          sortable: false
        },
        {
          key: 'member.sales.fullname',
          label: 'Sales',
          sortable: false
        },
        {
          key: 'pt_session',
          label: 'Buy PT',
          sortable: false,
          formatter: (value, key, item) => {
            return (item.last_buy_pt_session_name)
          },
        },
        {
          key: 'personal_training.name',
          label: 'Personal Trainer',
          formatter: (value, key, item) => {
            return (item.last_personal_trainer_name)
          },
          sortable: false
        },
        {
          key: 'expired_at',
          label: 'Expired Date',
          sortable: false
        },
        {
          key: 'actions',
          // class: 'text-center',
          label: 'Actions',
          sortable: false
        }
      ],
      branch_id: null,
      dataBranch: [],
      items: [],
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      getRoleId: Auth.Session.get().paradigm_role,
      totalPage: 0,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        // onChange: this.onChange
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    changeBranch(event) {
      console.log(event)
      this.fetchData()
    },
    onChangeDate(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      this.exportDates = dateStr
      if(this.exportDates.includes(" to ") === true) {
        this.fetchData()
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    parseCurrency(value) {
      // var newValue = value.toFixed()
      return value.toLocaleString('id-ID', {maximumFractionDigits:0})
    },
    openPage (event) {
      this.$router.push(event)
    },
    editGallery (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'compro/v1/img/gallery/' + value
    },
    exportReport() {
      let dates = this.exportDates.split(' to ')
      // console.log(dates)
      axios({
        method: 'get',
        url: 'fitness/v1/export/member_pt_session/not_assigned?page=&limit=&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        // link.download = 'Member Assign (PT Report) '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.download = 'Member Assign (PT Report).xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    enterClicked (searchEvent) {
      axios.get('fitness/v1/member_pt_session/not_assigned?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      let dates1 = this.exportDates.split(' to ')
      if(this.$route.query.last_page){
        this.currentPage = parseInt(this.$route.query.last_page)
      }
      axios.get('fitness/v1/member_pt_session/not_assigned?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id + '&start_date='+ dates1[0] + '&end_date='+dates1[1]).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })

      // branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows

        // for login PT SPV
        const is_pt_spv = Auth.Session.get().paradigm_role_mapping_id
        if (is_pt_spv.includes(22)) {
          this.branch_id = Auth.Session.get().paradigm_branch_id
          const find = this.dataBranch.find((m) => m.id == Auth.Session.get().paradigm_branch_id)
          if (find) {
            this.dataBranch = []
            this.dataBranch.push(find)
          }
        }

      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    const is_pt_spv = Auth.Session.get().paradigm_role_mapping_id
    if (is_pt_spv.includes(22)) {
      this.branch_id = Auth.Session.get().paradigm_branch_id
    }
    this.fetchData()
  }
}
</script>

<style>
</style>
